export const LOCAL_STORAGE = {
  xSessionId: 'x-session-id',
  incorrectPinCounter: 'incorrectPinCounter',
  pinRefreshToken: 'pinRefreshToken',
  salt: 'salt',
  xFingerprint: 'x-fingerprint',
  userLastActivityTime: 'userLastActivityTime',
  refreshTimer: 'refreshTimer',
  incorrectPinTimer: 'incorrectPinTimer',
  isAuthorized: 'isAuthorized',
  eqId: 'eqId',
  refCode: 'refCode',
  biometrics: 'biometrics',
  bioRefreshTimer: 'bioRefreshTimer',
  getFirstLoan: 'getFirstLoan',
  deviceId: 'deviceId',
  platform: 'platform ',
  deviceModel: 'deviceModel',
  savedPushToken: 'savedPushToken',
  utm_campaign: 'utm_campaign',
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_term: 'utm_term',
  utm_content: 'utm_content',
  gclid: 'gclid',
  fbclid: 'fbclid',
  ttclid: 'ttclid',
  gaid: 'gaid',
  xFingerprintVisitorId: 'x-fingerprint-visitor-id',
  xLandingFingerprintVisitorId: 'x-landing-fingerprint-visitor-Id',
  clickid: 'clickid',
  isApprovedScreenShown: 'isApprovedScreenShown',
  isNewClient: 'isNewClient',
  isNewApp: 'isNewApp',
  isNotFirst: 'isNotFirst',
  cameraGranted: 'cameraGranted',
  cameraDenied: 'cameraDenied',
  jumStart: 'jumStart',
  landingGaid: 'landingGaid',
  xLandingFingerprint: 'x-landing-fingerprint',
  isGgl: 'isGgl',
  wm_id: 'wm_id',
  utmPresent: 'utmPresent',
  fingerprintTrustDecision: 'fingerprintTrustDecision',
  landingFingerprintTrustDecision: 'landingFingerprintTrustDecision',
  analytics: 'analytics',
};

export const COOKIE_STORAGE = {
  refreshToken: 'refreshToken',
  accessToken: 'accessToken',
  idToken: 'idToken',
};

export const VISITOR_SOURCE = {
  pwa: 'pwa',
  mobApp: 'mobApp',
  landing: 'landing',
};
